import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  Renderer2,
  AfterViewInit,
} from '@angular/core';

@Directive({
  selector: '[lazyImg]'
})
export class LazyImgDirective implements AfterViewInit, OnDestroy {
  @Input('lazyImg') src!: string;

  private observer!: IntersectionObserver;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        this.renderer.setAttribute(this.el.nativeElement, 'src', this.src);
        this.observer.disconnect();
      }
    });
    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
